export default __webpack_public_path__ + "static/media/sort-down.903eaa19.svg";